import React, { useEffect, useState } from "react";
import AppBarChart from "../../AppBarChart/AppBarChart";
import HeaderStatistics from "../../HeaderStatistics/HeaderStatistics";
import Sidebar from "../../Sidebar/Sidebar";
import { Auth } from "aws-amplify";
import cloneDeep from "lodash/cloneDeep";
import DensityMediumIcon from '@mui/icons-material/DensityMedium';

import "./DashboardScreen.css";
import Header from "../../Header/Header";
import Leaderboard from "../../Leaderboard/Leaderboard";
import dayjs from "dayjs";
import { getAllUserDataApi } from "../../../Api";
import {
  aggregateData,
  aggregateDataByMonth,
  aggregateDataByUser,
  averageData,
  averageWeekPerMonth,
  filterDataByDate,
  filterDataByFields,
  filterDataByUser,
} from "../../../dataFunctions/functions";
import { useDispatch, useSelector } from "react-redux";
import { Widget } from "@typeform/embed-react";
import SidebarTable from "../../SidebarTable/SidebarTable";
import { Button } from "@nextui-org/react";

function DashboardScreen() {
  const [timeframe, setTimeframe] = useState("week");
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [dashType, setDashType] = useState("normal");
  const [userFilter, setUserFilter] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [allUserData, setAllUserData] = useState([]);

  const normalData = useSelector((state) => state.normalData.value);
  const recruitingData = useSelector((state) => state.recruitingData.value);
  const goals = useSelector((state) => state.goals.value);
  const userData = useSelector((state) => state.user.value);
  const dispatch = useDispatch();

  const handleTimeframeChange = (newTimeframe) => {
    setTimeframe(newTimeframe);

    if (newTimeframe === "custom") {
    } else {
      let newStartDate = startDate;
      let newEndDate = endDate;

      let today = new Date();

      if (newTimeframe === "this_week") {
        let thisWeekStart = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );
        // let previousWeekEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        while (thisWeekStart.getDay() !== 1) {
          thisWeekStart.setDate(thisWeekStart.getDate() - 1);
        }
        // while (previousWeekEnd.getDay() !== 0) {
        //   previousWeekEnd.setDate(previousWeekEnd.getDate() - 1);
        // }

        newStartDate = dayjs(thisWeekStart);
        newEndDate = dayjs(today);
      } else if (newTimeframe === "last_week") {
        let previousWeekStart = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 7
        );
        let previousWeekEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
        while (previousWeekStart.getDay() !== 1) {
          previousWeekStart.setDate(previousWeekStart.getDate() - 1);
        }
        while (previousWeekEnd.getDay() !== 0) {
          previousWeekEnd.setDate(previousWeekEnd.getDate() - 1);
        }

        newStartDate = dayjs(previousWeekStart);
        newEndDate = dayjs(previousWeekEnd);
      } else if (newTimeframe === "month") {
        newStartDate = dayjs(new Date(today.getFullYear(), today.getMonth(), 1));
        // newEndDate = dayjs(new Date(today.getFullYear(), today.getMonth() + 1, 0).setHours(24, 0, 0, -1))
        newEndDate = dayjs(today);
      } else if (newTimeframe === "year") {
        newStartDate = dayjs(new Date(today.getFullYear(), 0, 1));
        // newEndDate = dayjs(new Date(today.getFullYear(), 11, 31).setHours(24, 0, 0, -1))
        newEndDate = dayjs(today);
      }

      setStartDate(newStartDate);
      setEndDate(newEndDate);

      setUserFilter(getUsers(displayData));
    }
  };

  const getUsers = (displayData) => {
    console.log("Users:", displayData)
    console.log("allUserData:", allUserData)
    let users = [];

    if (displayData === null) {
      return users;
    }

    displayData.forEach((record) => {
      const found = users.find((user) => user.email === record.email || user.displayName === record.displayName) !== undefined ? true : false;
      const showFlag = allUserData.find((user) => user.email.toLowerCase() === record.email.toLowerCase()) !== undefined ? true : false;
      if (
        !found && 
        ((userData.role === "employee" && userData.email === record.email) ||
          userData.role === "manager" ||
          userData.role === "admin")
      ) {
        users.push({
          displayName: record.displayName,
          email: record.email,
          firstName: record.firstName,
          lastName: record.lastName,
          show : showFlag,
        });
      }
    });
    return users;
  };

  let displayData = normalData;
  if (dashType === "recruiting") {
    displayData = recruitingData;
  }

  const header = dashType === "recruiting" ? "Recruiting Dashboard" : "Core Four Dashboard";
  const chartInfos = [
    {
      x: "displayName",
      y: "total",
      chartTitle: "Total Points",
    },
    {
      x: "displayName",
      y: "opens",
      chartTitle: "New Opens",
    },
    {
      x: "month",
      y: "total",
      chartTitle: "Average Weekly Points",
    },
    {
      x: "displayName",
      y: "cois",
      chartTitle: "COI Meetings",
    },
    {
      x: "displayName",
      y: "contacts",
      chartTitle: "Contacts",
    },
    {
      x: "displayName",
      y: "intros",
      chartTitle: "Introductions",
    },
  ];

  const handleStartDateChange = (newStartDate) => {
    setStartDate(newStartDate);

    if (newStartDate > endDate) {
      setEndDate(newStartDate);
    }

    // setUserFilter(getUsers(
    //   filterDataByDate(displayData,
    //   newStartDate, endDate)
    // ))
    setUserFilter(getUsers(displayData));
  };

  const handleEndDateChange = (newEndDate) => {
    setEndDate(newEndDate);

    if (newEndDate < startDate) {
      setStartDate(newEndDate);
    }

    // setUserFilter(getUsers(
    //   filterDataByDate(displayData,
    //   startDate, newEndDate)
    // ))

    setUserFilter(getUsers(displayData));
  };

  const handleDashTypeChange = (newDashType) => {
    const displayData = newDashType === "normal" ? normalData : recruitingData;

    setUserFilter(getUsers(displayData));
    // setUserFilter(getUsers(
    //   filterDataByDate(displayData,
    //   startDate, endDate)
    // ))
    setDashType(newDashType);
  };

  const scaleGoalsToTimeframe = (goals, startDate, endDate) => {
    // Get 1 day in milliseconds
    let one_day = 1000 * 60 * 60 * 24;

    // Convert both dates to milliseconds

    let date1_ms = startDate.toDate().getTime();
    let date2_ms = endDate.toDate().getTime();

    // Calculate the difference in milliseconds
    let difference_ms = date2_ms - date1_ms;

    // Convert back to days and return
    let days = Math.round(difference_ms / one_day);

    let multiple = days / 7; // 7 because goals are set per week

    const scaledGoals = {};
    Object.keys(goals).forEach((goal) => {
      scaledGoals[goal] = Math.ceil(goals[goal] * multiple);
    });

    return scaledGoals;
  };

  const getEmpty = (numfields, strfields) => {
    const empty = {};
    numfields.forEach((field) => {
      empty[field] = 0;
    });
    strfields.forEach((field) => {
      empty[field] = "";
    });

    return empty;
  };

  const toggleUserFilter = (user) => {
    const newUserFilter = cloneDeep(userFilter);
    const index = userFilter.findIndex((filter) => filter.email == user.email);

    if (index === -1) {
      newUserFilter.push(user);
      setUserFilter(newUserFilter);
    } else {
      newUserFilter.splice(index, 1);
      setUserFilter(newUserFilter);
    }
  };

  const toggleAllUserFilter = (show) => {
    // console.log('show', show);
    setUserFilter(show ? getUsers(
      displayData 
    ) : []);
  }

  const calculateIncomeGoalGoals = (incomeGoals) => {
    // goals are stored by week, but income goals stores by year
    // to stay consistent, I divide the goals by 52 (weeks) to get income per week

    // const data = aggregateData(
    //   filterDataByFields(
    //     filterDataByUser(
    //       filterDataByDate(normalData,
    //       startDate, endDate),
    //     [userData]),
    //   ['opens', 'contacts', 'intros']
    // ))

    const data = aggregateData(
      filterDataByFields(filterDataByUser(displayData, [userData]), ["opens", "contacts", "intros"])
    );

    // const contactsPerOpen = 254/54
    const contactsPerOpen = data.contacts / data.opens;
    const introsPerOpen = data.intros / data.opens;

    // const investmentAvgCaseSize = incomeGoals.averageCaseSize
    const insuranceAvgCaseSize = incomeGoals.averageCaseSize;
    // const investmentConversionRate = 0.25
    const insuranceConversionRate = 0.25;

    // object for later scalability, only doing opens right now though

    const incomeGoalGoals = {};

    let totalOpens = 0;
    // const investmentOpens = ((incomeGoals.investmentGoal/52)/investmentAvgCaseSize)/investmentConversionRate
    const insuranceOpens =
      incomeGoals.insuranceGoal / 52 / insuranceAvgCaseSize / insuranceConversionRate;
    // totalOpens = investmentOpens + insuranceOpens
    totalOpens = insuranceOpens;

    incomeGoalGoals.opens = totalOpens;
    incomeGoalGoals.contacts = totalOpens * contactsPerOpen;
    incomeGoalGoals.intros = totalOpens * introsPerOpen;

    return incomeGoalGoals;
  };

  let scaledGoals = goals;
  scaledGoals = scaleGoalsToTimeframe(goals, startDate, endDate);

  let incomeGoalGoals = calculateIncomeGoalGoals(userData.incomeGoals);
  let scaledIncomeGoalGoals = scaleGoalsToTimeframe(incomeGoalGoals, startDate, endDate);

  const headerScale = filterDataByFields(
    aggregateDataByUser(
      filterDataByUser(filterDataByDate(displayData, startDate, endDate), userFilter)
    ),
    ["total"]
  ).length;

  const headerGoal = scaledGoals.total * Math.max(1, headerScale);

  const headerPoints = aggregateData(
    filterDataByFields(
      filterDataByUser(filterDataByDate(displayData, startDate, endDate), userFilter),
      ["total"]
    )
  )["total"];

  const getSidebarData = (fields) => {
    let data = aggregateData(
      filterDataByFields(
        filterDataByUser(filterDataByDate(displayData, startDate, endDate), userFilter),
        fields
      )
    );

    if (Object.keys(data).length === 0) {
      data = getEmpty(fields, []);
    }

    return data;
  };

  const getTimeseriesData = (fields) => {
    let data = filterDataByFields(
      averageWeekPerMonth(
        filterDataByFields(
          filterDataByUser(displayData, userFilter),
          fields.concat(["submissionTime"])
        )
      ),
      fields.concat(["month"])
    );
    return data;
  };

  const handleAllUserDataCallback = (rtndata) => {
    if (rtndata["status"] === "ERROR") {
      console.log("ERROR");
    } else {
      const cleanData = rtndata.data.filter(
        (user) => !!user.lastName && !!user.firstName && !!user.email
      );
      let uniqueUsers = [];
      const seen = new Set();
      for (const user of cleanData) {
        if (!seen.has(user.email.S)) {
          // Assuming 'username' is the unique attribute
          seen.add(user.email.S);
          uniqueUsers.push(user);
        }
      }
      const filteredData = uniqueUsers
        .map((rawUser) => {
          const cleanedUserData = {};

          cleanedUserData.id = rawUser.id.S;
          cleanedUserData.lastName = rawUser.lastName.S;
          cleanedUserData.firstName = rawUser.firstName.S;
          cleanedUserData.email = rawUser.email.S;
          cleanedUserData.loginHistory = [];

          if (rawUser.loginHistory) {
            cleanedUserData.loginHistory = rawUser.loginHistory.L.map((login) => {
              return parseInt(login.N);
            });
          }

          return cleanedUserData;
        })
        .filter((record) => !record.firstName.includes("Tristan"));

      setAllUserData(filteredData);
    }
  };

  useEffect(() => {
    getAllUserDataApi(handleAllUserDataCallback);
    // getDisplayData(normalData);
    handleTimeframeChange("this_week");
  }, []);

  return (
    <div className="relative flex justify-center">
      <Sidebar
        timeframe={timeframe}
        startDate={startDate}
        open={openDrawer}
        handleDrawerToggle={() => setOpenDrawer(!openDrawer)}
        endDate={endDate}
        setStartDate={handleStartDateChange}
        setEndDate={handleEndDateChange}
        handleTimeframeChange={handleTimeframeChange}
        users={getUsers(displayData)}
        userFilter={userFilter}
        toggleUserFilter={toggleUserFilter}
        toggleAllUserFilter={toggleAllUserFilter}
        dashType={dashType}
        handleDashTypeChange={handleDashTypeChange}
      />
       <Button
          color="primary"
          href="#"
          className="bg-[#002e62] top-3 left-3 min-w-[60px]"
          onClick={() => setOpenDrawer(!openDrawer)}
        >
          <DensityMediumIcon />
        </Button>
      <div className="p-8 w-[1296px]">
        {/* <div className="main-header">{header}</div> */}
        <h2 className="text-4xl font-bold text-[#002e62] text-center" style={{fontFamily: 'Madurai W01 Ext Bold'}}>Core Four Dashboard</h2>
        <div className="mt-6 flex justify-center gap-6">
          <div className="w-1/3">
            <Leaderboard
              displayField={"total"}
              tableColumnName={"Points"}
              data={
                // not using userFilter
                filterDataByFields(
                  aggregateDataByUser(filterDataByDate(displayData, startDate, endDate)),
                  ["displayName", "total"]
                )
              }
            />
          </div>
          <div className="w-1/3">
            <Leaderboard
              displayField={"perfectWeek"}
              tableColumnName={"Perfect Weeks"}
              data={
                // not using userFilter
                filterDataByFields(
                  aggregateDataByUser(filterDataByDate(displayData, startDate, endDate)),
                  ["displayName", "perfectWeek"]
                )
              }
            />
          </div>
        </div>
        <div className="mt-6 grid grid-cols-3 gap-6">
          {/* <SidebarTable data={getSidebarData(["opens", "cois", "contacts", "intros", "total"])} /> */}
          {chartInfos.map((info) => {
            let chartData;
            let chartGoal = scaledGoals[info.y];

            let chartIncomeGoal;
            if (Object.keys(scaledIncomeGoalGoals).includes(info.y)) {
              chartIncomeGoal = scaledIncomeGoalGoals[info.y];
              if (chartIncomeGoal == 0) {
                chartIncomeGoal = undefined;
              }
            }

            if (info.x === "month") {
              chartData = getTimeseriesData([info.y]);

              const now = new Date(); // Current date and time
              const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // First day of the month
              const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1); // Last day of the month
              // chartGoal = scaleGoalsToTimeframe(goals, dayjs(firstDayOfMonth.getTime()), dayjs(lastDayOfMonth.getTime()))[info.y];

              chartGoal = goals[info.y];

              let userScale;

              if (userData.role === "employee") {
                userScale = 1;
              } else {
                userScale = userFilter.length;
              }

              chartGoal = chartGoal * userScale;
            } else {
              chartData = filterDataByFields(
                aggregateDataByUser(
                  filterDataByUser(filterDataByDate(displayData, startDate, endDate), userFilter)
                ),
                [info.x, info.y]
              );

              chartData.sort((a, b) => b[info.y] - a[info.y]);

              if (userData.role === "employee") {
                const averageRecord = averageData(
                  filterDataByFields(
                    aggregateDataByUser(filterDataByDate(displayData, startDate, endDate)),
                    [info.y]
                  )
                );

                averageRecord["displayName"] = "Average";

                // add a bar for the average
                chartData.push(averageRecord);
              }
            }

            console.log('data', chartData)

            return (
              <AppBarChart
                goal={chartGoal}
                incomeGoal={chartIncomeGoal}
                data={chartData}
                displayField={info.y}
                xFieldName={info.x}
                header={info.chartTitle}
                key={info.x + "" + info.y}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DashboardScreen;
